import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import Icon from '@ro-atoms/Icon';
import Button from '@material-ui/core/Button';

import Tutorial from '@ro-components/Tutorial';
import { setTooltipProperties } from '@ro-utils/ui';
import { setRoTooltip } from '@ro-utils/map';
import { Flex, Box } from '@rebass/grid';
import { getDistance } from '@ro-utils/common/radar-params';

import { Tooltip, PickerBoard, Container, TooltipContent, SpIconWrapper } from './RoTooltip.styles';

import RoLine from '../RoLine';

import { Cell, BodyRow } from '../RoTable';
import { Props, State } from './RoTooltip.types';
import Overlay from 'ol/Overlay';

import { TooltipHeader, Lightnings, Warnings, Radar } from './Components';
import { LocationDescriptorObject } from 'history';
//import RenderEvent from 'ol/render/Event';

class RoTooltip extends Component<Props, State> {
  tooltip: Overlay | false = false;
  state: State = {
    lines: true,
    timestamp: +new Date(),
    scan: this.props.scan
  };

  componentDidMount() {
    // const target = this.props.map.getTargetElement();
    // console.log('mounted');
    // target.addEventListener('mouseup', (e: any) => {
    //   return this.setState({
    //     center: this.props.map.getView().getCenter()[0],
    //     lines: true
    //   });
    // });
    // target.addEventListener('mousedown', (e: any) => {
    //   return this.setState({
    //     lines: false
    //   });
    // });
  }

  toStr(obj: any) {
    return JSON.stringify(obj);
  }

  shouldComponentUpdate(nextProps: Props, prevState: State) {
    if (
      this.state.center !== prevState.center ||
      this.state.scan !== nextProps.scan ||
      this.toStr(this.props.currentLocation) !== this.toStr(nextProps.currentLocation) ||
      this.toStr(this.props.favoriteList) !== this.toStr(nextProps.favoriteList) ||
      this.props.userSettings.tutorialLevel !== nextProps.userSettings.tutorialLevel
    ) {
      return true;
    }
    return false;
  }

  componentDidUpdate() {
    setRoTooltip(this.props.currentLocation, this.tooltip, this.props.map);
  }

  getBounding() {
    const handleObj = document.getElementById('roHandle_1');
    const handle = handleObj && handleObj.getBoundingClientRect();
    const pixelCoord =
      this.props.currentLocation.transformed &&
      this.props.map.getPixelFromCoordinate(this.props.currentLocation.transformed);
    return {
      handle: handle || 0,
      pixelCoord
    };
  }

  convertToClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const evt = new MouseEvent('click', { bubbles: true });
    evt.stopPropagation = () => {};
    e.target.dispatchEvent(evt);
  };

  render() {
    const {
      legendColors,
      legendMap,
      legendUnit,
      history,
      currentLocation,
      map,
      onShowSnack,
      favoriteList,
      legendUnitText,
      legendIcon
    } = this.props;

    const bounding = this.getBounding();

    const tooltipProps = setTooltipProperties(this.props, map);

    const synopData = tooltipProps && tooltipProps.nearestSynop && tooltipProps.nearestSynop.synop;
    const snowData = tooltipProps && tooltipProps.nearestSnowSynop && tooltipProps.nearestSnowSynop.synop;

    let pickerValue, pickerBoardPosition;
    const distance: any = !!tooltipProps && tooltipProps.color && getDistance(tooltipProps.color, legendColors);

    if (distance) {
      pickerValue = legendMap[distance.color];
      const index = legendColors.indexOf(distance.color);
      const length = legendColors.length;
      pickerBoardPosition = (index * 100) / length;
    }
    const disableLine = true;
    return (
      <Fragment>
        {this.state.lines && !disableLine && (
          <RoLine
            location={this.props.location}
            bounding={{
              ...bounding,
              pickerBoardPosition: pickerBoardPosition
            }}
          />
        )}
        <Tooltip>
          <Container id="RoTooltip" onMouseUp={this.convertToClick}>
            {!!tooltipProps && (
              <TooltipContent className={'ro_tooltip'}>
                <Table>
                  <TooltipHeader
                    text={this.props.text}
                    currentLocation={currentLocation}
                    onShowSnack={onShowSnack}
                    favoriteList={favoriteList}
                  />
                  <TableBody>
                    {(this.props.label || synopData?.stacja || snowData) && (
                      <BodyRow clickable>
                        <Cell colSpan={2}>
                          <Flex>
                            <Box px={0}>
                              <SpIconWrapper color="#fff" bg="#000" size={30}>
                                <Icon name="chart-bar fas" />
                              </SpIconWrapper>
                            </Box>
                            {this.props.label && (
                              <Box pl={2}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  size="small"
                                  onClick={() =>
                                    history.push({
                                      pathname: '/meteogram/',
                                      state: { ...tooltipProps, currentLocation },
                                      finalLocation: currentLocation
                                    } as LocationDescriptorObject)
                                  }
                                >
                                  Meteogram
                                </Button>
                              </Box>
                            )}
                            {synopData?.stacja && (
                              <Box pl={2}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  size="small"
                                  onClick={() => {
                                    history.push({
                                      pathname: '/synop/',
                                      state: { ...tooltipProps, currentLocation }
                                    });
                                  }}
                                >
                                  Stacja&nbsp;IMiGW&nbsp;{synopData?.stacja}
                                </Button>
                              </Box>
                            )}
                            {snowData && (
                              <Box pl={2}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  size="small"
                                  onClick={e =>
                                    history.push({
                                      pathname: '/warunki-sniegowe/',
                                      state: { ...tooltipProps, currentLocation }
                                    } as LocationDescriptorObject)
                                  }
                                >
                                  <Icon name="snowflake fas" />
                                </Button>
                              </Box>
                            )}
                          </Flex>
                        </Cell>
                      </BodyRow>
                    )}
                    <Radar
                      legendUnitText={legendUnitText}
                      legendIcon={legendIcon}
                      tooltipProps={tooltipProps}
                      pickerValue={pickerValue}
                      legendUnit={legendUnit}
                      distance={distance}
                    />
                    <Warnings tooltipProps={tooltipProps} />
                    <Lightnings lightningsData={this.props.lightningsData} currentLocation={currentLocation} />
                  </TableBody>
                </Table>
              </TooltipContent>
            )}
          </Container>
          {!!pickerBoardPosition && (
            <PickerBoard id="pickerBoard" position={pickerBoardPosition}>
              {`${pickerValue.value.toFixed(2)} ${legendUnit}`}
            </PickerBoard>
          )}
        </Tooltip>
        {!!tooltipProps && (
          <Tutorial
            //@ts-ignore
            name="tooltip"
          />
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = (state: any) => ({
  ...state.ro.legend,
  userSettings: state.ro.userSettings
});

export default connect(mapStateToProps)(RoTooltip);
